//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum COMPETITORS_ROUTES {
  INSIGHTS = 'instagramAccount.competitors.insights',
  MEDIA = 'instagramAccount.competitors.media',
}

export enum CompetitorsSortKey {
  ACCOUNT = 'ACCOUNT',
  FOLLOWERS = 'FOLLOWERS',
  FOLLOWER_GROWTH = 'FOLLOWER_GROWTH',
  POSTS = 'POSTS',
  AVG_LIKES = 'AVG_LIKES',
  AVG_COMMENTS = 'AVG_COMMENTS',
  ENGAGEMENT = 'ENGAGEMENT',
}

export const orderedHeaders = [
  CompetitorsSortKey.ACCOUNT,
  CompetitorsSortKey.FOLLOWERS,
  CompetitorsSortKey.FOLLOWER_GROWTH,
  CompetitorsSortKey.POSTS,
  CompetitorsSortKey.AVG_LIKES,
  CompetitorsSortKey.AVG_COMMENTS,
  CompetitorsSortKey.ENGAGEMENT,
];

export enum CompetitorsSortDir {
  ASC = 'Asc',
  DESC = 'Desc',
}

export enum CompetitorsSortVar {
  ACCOUNT = 'username',
  FOLLOWERS = 'followers',
  FOLLOWER_GROWTH = 'followerGrowth',
  POSTS = 'posts',
  AVG_LIKES = 'avgLikesPerPost',
  AVG_COMMENTS = 'avgCommentsPerPost',
  ENGAGEMENT = 'avgFollowerEngRate',
}

export enum ManagedCompetitorStatus {
  TO_ADD = 'toAdd',
  TO_REMOVE = 'toRemove',
}

export const COMPETITORS_INSIGHTS_TABLE_TOOLTIPS = {
  FOLLOWERS: 'Total number of followers.',
  FOLLOWER_GROWTH:
    'Net change in follower count over the selected time period.',
  POSTS: 'Number of organic posts published within the selected time period.',
  AVG_LIKES: `The total number of likes divided by the total number of organic posts
    published within the selected time period.`,
  AVG_COMMENTS: `The total number of comments divided by the total number of organic posts
    published within the selected time period.`,
  ENGAGEMENT: `Total likes plus comments divided by sum of follower
    count across organic posts that were posted in the selected time period.`,
};

export const COMPETITORS_INSIGHTS_TABLE_TITLES = {
  ACCOUNT: 'Account',
  FOLLOWERS: 'Followers',
  FOLLOWER_GROWTH: 'Net Flwr. Growth',
  POSTS: 'Posts',
  AVG_LIKES: 'Avg. Likes/Post',
  AVG_COMMENTS: 'Avg Comments/Post',
  ENGAGEMENT: 'Flwr. Eng. Rate',
};

export enum CompetitorsTrendMetric {
  TOTAL_FOLLOWERS = 'totalFollowers',
  CHANGE_IN_FOLLOWERS = 'changeInFollowers',
  FOLLOWER_ENG_RATE = 'followerEngRate',
  POSTS = 'posts',
}

export const COMPETITORS_TREND_METRICS_LABELS = {
  [CompetitorsTrendMetric.TOTAL_FOLLOWERS]: 'Total Followers',
  [CompetitorsTrendMetric.CHANGE_IN_FOLLOWERS]: 'Change In Followers',
  [CompetitorsTrendMetric.FOLLOWER_ENG_RATE]: 'Follower Eng. Rate',
  [CompetitorsTrendMetric.POSTS]: 'Posts',
};

export const COMPETITORS_TREND_METRICS_OPTIONS = [
  {
    label:
      COMPETITORS_TREND_METRICS_LABELS[
        CompetitorsTrendMetric.FOLLOWER_ENG_RATE
      ],
    value: CompetitorsTrendMetric.FOLLOWER_ENG_RATE,
  },
  {
    label:
      COMPETITORS_TREND_METRICS_LABELS[CompetitorsTrendMetric.TOTAL_FOLLOWERS],
    value: CompetitorsTrendMetric.TOTAL_FOLLOWERS,
  },
  {
    label:
      COMPETITORS_TREND_METRICS_LABELS[
        CompetitorsTrendMetric.CHANGE_IN_FOLLOWERS
      ],
    value: CompetitorsTrendMetric.CHANGE_IN_FOLLOWERS,
  },
  {
    label: COMPETITORS_TREND_METRICS_LABELS[CompetitorsTrendMetric.POSTS],
    value: CompetitorsTrendMetric.POSTS,
  },
];

export enum CompetitorMediaSort {
  MOST_RECENT = 'PostedTimestamp',
  LIKES = 'Likes',
  COMMENTS = 'Comments',
  FOLLOWER_ENG_RATE = 'Engagement',
}

export const COMPETITOR_MEDIA_SORT_LABELS = {
  [CompetitorMediaSort.MOST_RECENT]: 'Most Recent',
  [CompetitorMediaSort.LIKES]: 'Most Likes',
  [CompetitorMediaSort.COMMENTS]: 'Most Comments',
  [CompetitorMediaSort.FOLLOWER_ENG_RATE]: 'Highest Follower Eng. Rate',
};

export const COMPETITOR_MEDIA_SORT_OPTIONS = [
  {
    label: COMPETITOR_MEDIA_SORT_LABELS[CompetitorMediaSort.MOST_RECENT],
    value: CompetitorMediaSort.MOST_RECENT,
  },
  {
    label: COMPETITOR_MEDIA_SORT_LABELS[CompetitorMediaSort.LIKES],
    value: CompetitorMediaSort.LIKES,
  },
  {
    label: COMPETITOR_MEDIA_SORT_LABELS[CompetitorMediaSort.COMMENTS],
    value: CompetitorMediaSort.COMMENTS,
  },
  {
    label: COMPETITOR_MEDIA_SORT_LABELS[CompetitorMediaSort.FOLLOWER_ENG_RATE],
    value: CompetitorMediaSort.FOLLOWER_ENG_RATE,
  },
];

export const COMPETITORS_MEDIA_GRID_WIDTH = 880;

const instagramCompetitorsPrefix = 'ig-competitors-';

export const instagramCompetitorsTrackingIds = {
  EMPTY_STATE_ADD_COMPETITORS_BUTTON: `${instagramCompetitorsPrefix}empty-state-add-competitors-button`,
};
